import React from 'react';
import { useTranslation } from 'react-i18next';

import { FeatureErrorBoundary, FeatureErrorState } from '../../core-components/theme/components/FeatureErrorBoundary';

const RouteErrorFallback: React.FC<{ onRetry: () => void }> = ({ onRetry }) => {
  const { t } = useTranslation();
  return (
    <FeatureErrorState
      align="start"
      title={t('routeError.title', 'Something went wrong on this screen')}
      body={t('routeError.body', 'The error has been reported. You can try again.')}
      retryLabel={t('routeError.retry', 'Try again')}
      onRetry={onRetry}
    />
  );
};

export const guardedRoute = (
  feature: string,
  node: React.ReactNode,
  resetKeys?: readonly unknown[],
): React.ReactElement => (
  <FeatureErrorBoundary feature={feature} resetKeys={resetKeys} fallback={(reset) => <RouteErrorFallback onRetry={reset} />}>
    {node}
  </FeatureErrorBoundary>
);
